import { render, staticRenderFns } from "./userInfoNav.vue?vue&type=template&id=54aae410&scoped=true"
import script from "./userInfoNav.vue?vue&type=script&lang=js"
export * from "./userInfoNav.vue?vue&type=script&lang=js"
import style0 from "./userInfoNav.vue?vue&type=style&index=0&id=54aae410&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aae410",
  null
  
)

export default component.exports